// import './App.css';
// import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
// import Navbar from './Component/NavBar/NavBar';
// import HomePage from './Component/Home/Home';
// import Footer from './Component/Footer/Footer';
// import Tours from './Component/Tours/Tours';
// import About from './Component/About/About';
// import Contact from './Component/Contact/Contact';
// import { CartProvider } from './Component/Cart/CartContext';
// import Cart from './Component/Cart/Cart';
// import JoinListTrigger from './Component/JoinList/Joinlisttrigger';
// import BookingSuccess from './Component/Booking/Bookingsuccess';
// import BookingFailed from './Component/Booking/BookingFailed';
// import ErrorPage from './Component/ErrorPage/Error';
// import { useEffect } from 'react';

// function ScrollToTop() {
//   const { pathname } = useLocation();
//   useEffect(() => {
//     window.scrollTo({ top: 0, left: 0, behavior: "instant" });
//   }, [pathname]);
//   return null;
// }

// // ── Wrapper reads current path and hides chrome on booking pages ──
// function AppLayout() {
//   const location = useLocation();
//   const showLayoutPaths = [
//     '/',
//     '/home',
//     '/tours',
//     '/about',
//     '/contact'
//   ];

//   const showLayout = showLayoutPaths.includes(location.pathname);

//   return (
//     <>
//       <ScrollToTop />
//       {showLayout && <Navbar />}

//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/home" element={<HomePage />} />
//         <Route path="/tours" element={<Tours />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/booking/success" element={<BookingSuccess />} />
//         <Route path="/booking/failed" element={<BookingFailed />} />
//         <Route path="*" element={<ErrorPage />} />
//       </Routes>

//       {showLayout && <Footer />}
//       <Cart />
//       <JoinListTrigger />
//     </>
//   );
// }

// function App() {
//   return (
//     <CartProvider>
//       <BrowserRouter>
//         <AppLayout />
//       </BrowserRouter>
//     </CartProvider>
//   );
// }

// export default App;



import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import store from './store/store';

import CookieBanner from "./Component/Paneldriver/Cookiebanner";
import { refreshCookieState } from "./Component/Paneldriver/DriverSlice/Driverslice";

// Components
import VegasKarts from './Component/Vegaskarts/Vegaskarts';
import TermsOfService from './Component/Paneldriver/Terms';
import LiabilityWaiver from './Component/Paneldriver/Waiver';
import VerifiedPage from './Component/Paneldriver/Verifiedpage';
import BookingSuccess from './Component/Paneltours/TourSuccess';
import BookingFailed from './Component/Paneltours/TourFailed';


// ✅ NEW: Inner component (ahi useDispatch safe che)
function AppContent() {
  const dispatch = useDispatch();

  const handleCookieDecision = (decision) => {
    dispatch(refreshCookieState());
  };

  return (
    <>
      <BrowserRouter>
        <Routes>

          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/waiver" element={<LiabilityWaiver />} />
          <Route path="/verified" element={<VerifiedPage />} />

          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/booking/failed" element={<BookingFailed />} />

          <Route path="/" element={<VegasKarts />} />
          <Route path="/about" element={<VegasKarts />} />
          <Route path="/kart" element={<VegasKarts />} />
          <Route path="/tours" element={<VegasKarts />} />
          <Route path="/driver" element={<VegasKarts />} />
          <Route path="/missions" element={<VegasKarts />} />
          <Route path="/trophies" element={<VegasKarts />} />
          <Route path="/contact" element={<VegasKarts />} />
          <Route path="/event" element={<VegasKarts />} />

          <Route path="*" element={<VegasKarts />} />
        </Routes>
      </BrowserRouter>

      <CookieBanner onDecision={handleCookieDecision} />
    </>
  );
}


// ✅ MAIN App (Provider ahi che)
function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
